// extracted by mini-css-extract-plugin
module.exports = {"privacy":"privacy-module--privacy--1pSbK","accessibility":"privacy-module--accessibility--UwNWU"};